import { useState, useContext, useEffect } from "react";
import { useFirestoreOrderBy } from "../../firebase/useFirestore";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { db } from "../../firebase/config";
import uuid from "react-uuid";
import { timestamp } from "../../firebase/config";
import { client } from "../../hooks/Client";
import DragIndicatorOutlinedIcon from "@mui/icons-material/DragIndicatorOutlined";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import PairActivities from "./PairActivities";
import Table from "../common/table/Table.jsx";
import TableCell from "../common/table/TableCell.jsx";
import softDeleteDoc from "../../helpers/softDeleteDoc.js";
import { Auth } from "../../StateManagment/Auth";

const StorytellingQuotesTab = () => {
  const [, setSaved] = useContext(SavedIcon);
  const [auth] = useContext(Auth);
  const [dragArrayQuotes, setDragArrayQuotes] = useState([]);

  const quotes = useFirestoreOrderBy("Quotes", "Position", "asc");
  const activities = useFirestoreOrderBy("Activities", "Position", "asc");

  useEffect(() => {
    setDragArrayQuotes(quotes || []);
  }, [quotes]);

  const handleDragEndQuotes = (result) => {
    if (!result.destination) return;

    const items = Array.from(dragArrayQuotes);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    setDragArrayQuotes(items);

    items.forEach((item, idx) => {
      db.collection("Quotes").doc(item.docid).update({ Position: idx + 1 });
    });

    setSaved("flex");
  };

  const addQuote = () => {
    db.collection("Quotes").doc().set({
      Quote: "",
      Name: "",
      ID: uuid(),
      Timestamp: timestamp,
      CompagnyID: client,
      Position: (quotes?.length || 0) + 1,
      Type: "Quote",
    });
  };

  const quoteTitleHandler = (e) => {
    const docid = e.target.dataset.docid;
    const quote = e.target.value;

    db.collection("Quotes").doc(docid).update({ Quote: quote });
  };

  const quoteNameHandler = (e) => {
    const docid = e.target.dataset.docid;
    const name = e.target.value;

    db.collection("Quotes").doc(docid).update({ Name: name });
  };

  // Zacht verwijderen (ADR-008), zodat een misklik terug te halen is uit de
  // prullenbak. De hooks filteren gemarkeerde documenten centraal weg.
  // `currentTarget`: bij een MUI-icoon is `target` het <path> eronder, en dat
  // draagt de data-docid niet.
  const deleteQuoteItem = async (e) => {
    const docid = e.currentTarget.dataset.docid;
    if (!docid) return;

    await softDeleteDoc({ collection: "Quotes", docid, authId: auth?.ID });
    setSaved("flex");
  };

  return (
    <>
      <Table
        columns={[
          { key: "drag", label: "", searchable: false },
          { key: "quote", label: "QUOTE" },
          { key: "name", label: "NAAM", searchable: false },
          { key: "activities", label: "ACTIVITEIT(EN)", searchable: false },
          { key: "delete", label: "VERWIJDEREN", searchable: false },
        ]}
        items={dragArrayQuotes || []}
        getItemKey={(item) => item.ID}
        renderRow={(item) => (
          <>
            <TableCell>
              <DragIndicatorOutlinedIcon />
            </TableCell>
            <TableCell>
              <input
                type="text"
                placeholder="Schrijf hier de quote"
                data-docid={item.docid}
                defaultValue={item.Quote}
                onChange={quoteTitleHandler}
              />
            </TableCell>
            <TableCell>
              <input
                type="text"
                placeholder="Schrijf hier de naam"
                data-docid={item.docid}
                defaultValue={item.Name}
                onChange={quoteNameHandler}
              />
            </TableCell>
            <TableCell>
              <PairActivities type={"Quotes"} item={item} activities={activities} setSaved={setSaved} />
            </TableCell>
            <TableCell>
              <DeleteOutlinedIcon className="table-delete-icon" data-docid={item.docid} onClick={deleteQuoteItem} />
            </TableCell>
          </>
        )}
        searchAccessor={(item) => item?.Quote || ""}
        searchPlaceholder="Zoeken op quote"
        emptyMessage="Geen quotes gevonden."
        draggable
        droppableId="quotes"
        onDragEnd={handleDragEndQuotes}
        addRow={{
          toolTipContent: "Quote toevoegen",
          onClick: addQuote,
        }}
      />
    </>
  );
};

export default StorytellingQuotesTab;
